<template>
  <div id="onboarding-page" name="onboarding-page" class="page" @page:beforein="beforein" @page:beforeout="beforeout" @page:afterin="afterin">
      <div class="block onboarding">
        <f7-row>
          <f7-col class="al">
            <img :src="require('@/assets/img/logo-wandr_e.svg')" style=""  class="logo"/>
          </f7-col>

          <f7-col class="ar">
            <!--<langSwitch class="mt-sm" />-->
          </f7-col>
        </f7-row>

        <f7-row><div class="text-onboarding" v-html="text1"></div></f7-row>
        <f7-row><div class="mt-xl fs-16 b sub-text-onboarding" style="" v-html="text2"></div></f7-row>
        <f7-row>
          <f7-button href="/login" :disabled="disableButton" class="w-100 mb-md" large fill>
            {{$t('general-btn-login')}}
          </f7-button>

          <f7-button href="/register" :disabled="disableButton" large outline class="w-100 mb-xxl">
            {{$t('general-btn-register')}}
          </f7-button>

          <div class="mt-sm d-none">
            {{$t('onboarding-text-theme')}} <f7-toggle @change="changeTheme" class="ml-sm"></f7-toggle>
          </div>
        </f7-row>
      </div>
  </div>
</template>

<script>
  //import langSwitch from '@/components/lang-switch'
  import TokenService from '../services/token-service';
  import ApiService from '../services/api-main';
  import { mapActions, mapGetters } from "vuex";

  export default {
    data(){
      return {
        isNextButtonValid : true,
        dvc: this.$f7.device,
        disableButton: true,
        text1: "",
        text2: "",
      }
    },
    mounted(){
      const appRedirPath = this.$api.misc.checkDeviceRedirect(this.dvc)
      if(appRedirPath){ window.location.href = appRedirPath; return; }

      const imgURL = this.getImg('logo-wandr_e-compact.svg')

      this.text1 = this.$t('onboarding-text', [imgURL])
      this.text2 = this.$t('onboarding-text2', [imgURL])

      this.determineAppBranchId(this.dvc.desktop)
    },
    methods: {
      ...mapActions('auth', ['refreshToken', 'setMaintenanceMode', 'resetLoginState']),
      ...mapActions('misc', ['determineAppBranchId', 'setGuestBgMode']),
      ...mapActions('registration', ['resetRegistrationState', 'setIsAxsr']),
      changeTheme(e){
        let $$ = this.Dom7;
        const el = $$("html");
        e.target.checked
          ? el.addClass("theme-dark")
          : el.removeClass("theme-dark");
      },
      getImgUrl(){
          return require('../assets/img/flags/flag_189.png')
      },
      async beforein(){
        this.setGuestBgMode(true)
        this.disableButton = true
        
        this.resetLoginState();
        this.resetRegistrationState();
        console.log("maintenanceMode " + this.maintenanceMode)
        this.setMaintenanceMode(false);
        // if (!this.maintenanceMode) {
          if (TokenService.getToken()) {
            let valid = this.checkTokenExpiry(true, this.navigateHome)
            if (valid) {
              await this.refreshToken()
              if(this.loggedIn) {
                ApiService.mount401Interceptor();
                this.navigateHome();
                if(this.$store.state.misc.redirectToPath != '') {
                  setTimeout(() => {
                    const paths = this.$store.state.misc.redirectToPath.split("?");
                    this.navigateRoute(paths[0], (paths.length == 1)?undefined:paths[1]);
                  }, 3000)
                }
              }
            }
          }
        // } else {
        //   this.setMaintenanceMode(false);
        // }

        this.disableButton = false
        this.setIsAxsr(false)
      },
      beforeout(){
        this.setGuestBgMode(true) // <-- set to true for WA-355
      },
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      navigateHome(){
        this.$f7router.navigate("/home", { transition: 'f7-fade', clearPreviousHistory  : true });
      },
    },
    components: {
      //langSwitch
    },
    computed: {
      ...mapGetters('auth', ['loggedIn','maintenanceMode'])
    },
  }
</script>